import * as React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 27"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="98.993%" id="df3bhlfmwb">
        <stop stopColor="#71ECDA" offset="0%" />
        <stop stopColor="#32B8C0" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="xdy8s2o6da">
        <stop stopColor="#98F3E7" offset="0%" />
        <stop stopColor="#66D0D5" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M11.5.821c2.85 0 5.43 1.155 7.297 3.023a10.287 10.287 0 0 1 3.023 7.297c0 2.468-1.54 5.495-3.44 8.161-2.494 3.499-5.655 6.52-6.88 6.52-1.225 0-4.386-3.021-6.88-6.52-1.9-2.666-3.44-5.693-3.44-8.161 0-2.85 1.155-5.43 3.023-7.297A10.287 10.287 0 0 1 11.5.82Z"
        stroke="url(#xdy8s2o6da)"
        fill="url(#df3bhlfmwb)"
      />
      <path
        d="M14.614 8.323h-.528v-.76c0-.31-.345-.563-.767-.563H9.68c-.422 0-.767.253-.767.563v.76h-.528C7.624 8.323 7 8.925 7 9.661v5.001C7 15.398 7.624 16 8.386 16h6.228c.762 0 1.386-.602 1.386-1.338V9.661c0-.736-.624-1.338-1.386-1.338Zm-1.185 4.108c-.001.247-.21.446-.468.447h-.66v.63c-.001.246-.21.446-.468.447h-.666a.459.459 0 0 1-.468-.447v-.63h-.66a.459.459 0 0 1-.468-.447v-.635c.001-.247.21-.446.468-.447h.66v-.63c.001-.246.21-.446.468-.446h.666c.258 0 .467.2.468.446v.63h.66c.258.002.467.2.468.447v.635Zm0-4.204H9.57v-.443c0-.206.232-.375.516-.375h2.826c.283 0 .515.169.515.375v.443Z"
        fill="#F7FFFF"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComponent
